import React, { useState, useEffect } from "react"
import _ from "lodash"
import { alphanum, systemWildcardFirst } from "components/table/lib/sort"

import { CheckboxInput, ListboxInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

import propertyService from "data/property"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

const Detailed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {}
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<object|null>(props.rowData[props.field]);
  const [showSelected, setShowSelected] = useState<boolean>(false);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'detailed') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    if (field === 'items'){
      let items = val
      if (items && items[0] === "") items.shift();
      items = items.map(item => { return { 'recoveryNamedItemId': item }})
      nextData[field] = items
    } else {
      nextData[field] = val
    }
    setData(nextData);
    props.persist({...nextData, state: 'detailed'}, 'recoverygroupdetail', props.rowData)
  }

  const attrs             = (field) => field_attrs('recoverygroup')(field)(props.rowData, props)
  const property          = propertyService.get();
  let namedRecoveries      = props.namedItems['namedRecoveries'];
  let recoveryGroupsData  = _.cloneDeep(data);
  recoveryGroupsData      = recoveryGroupsData && recoveryGroupsData['items'] ? recoveryGroupsData['items'].map(item => item.recoveryNamedItemId) : null

  if (showSelected && recoveryGroupsData){
    namedRecoveries = namedRecoveries.filter(recoveryGroup => recoveryGroupsData.includes(recoveryGroup.recoveryid));
  }

  function selectAll():void {
    data && data['items'] && data['items'].length === namedRecoveries.length ? updateData([], 'items') : updateData(namedRecoveries.map(leaseType => leaseType.recoveryid), 'items')
  }

  if (sortDirty){
    sortAsc ? namedRecoveries.sort((a, b) => alphanum(a.name, b.name)).sort((a, b) => systemWildcardFirst(a.name, b.name)) : namedRecoveries.sort((a, b) => alphanum(b.name, a.name)).sort((a, b) => systemWildcardFirst(a.name, b.name))
  }

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Named Recoveries</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: recoveryGroupsData ? recoveryGroupsData.length === namedRecoveries.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": recoveryGroupsData}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={updateData}
            options={namedRecoveries.map(namedRecovery => { return {label: `${namedRecovery.code} - ${namedRecovery.name}`, value: namedRecovery.recoveryid}})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default Detailed
